import { TranslationKey } from "@/models/translationSchema";
import { useTranslation as useTranslationOriginal } from "next-i18next";
import { useCallback } from "react";

/**
 * Patch the useTranslation function to return a type-safe translation function
 */
export function useTranslation(namespace: string = "common") {
  const { t } = useTranslationOriginal(namespace);

  const tTypeSafe = useCallback(
    <Key extends TranslationKey>(
      key: Key,
      vars?: Record<string, string | number>
    ): string => {
      return t(key as unknown as string, vars);
    },
    [t]
  );

  return {
    t: tTypeSafe,
  };
}
